document.addEventListener("DOMContentLoaded", function () {
    let currentDate = new Date().setHours(0, 0, 0, 0); // Reset to start of day
    let lastPopupTime = localStorage.getItem("popup_last_shown");

    // Function to hide pop-up and save the date
    function hidePopup() {
        document.getElementById("popup-overlay").style.display = "none";
        document.getElementById("popup-box").style.display = "none";
        localStorage.setItem("popup_last_shown", currentDate); // Save today's date
    }

    // Show pop-up only if it hasn't been shown today
    if (!lastPopupTime || parseInt(lastPopupTime) !== currentDate) {
        setTimeout(function () {
            document.getElementById("popup-overlay").style.display = "flex";
            document.getElementById("popup-box").style.display = "block";
        }, 1000);
    }

    // Close on button click
    document.getElementById("popup-close").addEventListener("click", hidePopup);

    // Close on outside click
    document.getElementById("popup-overlay").addEventListener("click", function (event) {
        if (event.target === this) {
            hidePopup();
        }
    });
});
